export default function VerificationLayout({ children }) {
  return (
    <div className="max-w-md mx-auto bg-white">
      <div className="bg-[#EDF3FF] p-6 rounded-3xl flex flex-col items-center min-h-screen">
        <h2 className="text-2xl font-bold mb-10 text-center">OSHIMED</h2>
        <div className="w-full flex flex-col items-center">{children}</div>
      </div>
    </div>
  )
}
